import { Gift, ArrowRight } from 'lucide-react';

interface ReferralBannerProps {
    onBecomePartner: () => void;
}

// High-visibility referral promo — placed between pricing and the footer so it's
// hard to miss without hijacking the top of the page.
const ReferralBanner = ({ onBecomePartner }: ReferralBannerProps) => {
    return (
        <section className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
            <div className="relative mx-auto overflow-hidden rounded-3xl bg-gradient-to-br from-[#FF6B35] to-[#ff5722] px-6 py-10 md:px-12 md:py-12">
                {/* Decorative glow */}
                <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/10 blur-2xl" />
                <div className="pointer-events-none absolute -bottom-20 -left-10 h-64 w-64 rounded-full bg-black/10 blur-2xl" />

                <div className="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
                    <div className="max-w-2xl">
                        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white backdrop-blur-sm">
                            <Gift className="h-4 w-4" />
                            Referral Program
                        </span>

                        <h2 className="mt-4 text-3xl font-bold leading-tight text-white md:text-4xl lg:text-5xl">
                            Earn up to ₦90,000
                        </h2>

                        <p className="mt-4 text-base leading-relaxed text-white/90 md:text-lg">
                            Know someone who's hiring or needs background checks? Refer them to YourChecka and earn{' '}
                            <span className="font-bold text-white">10% commission</span> when they verify their
                            employee.
                        </p>

                        <p className="mt-3 text-xs text-white/70">Terms &amp; Conditions apply.</p>
                    </div>

                    <div className="shrink-0">
                        <button
                            type="button"
                            onClick={onBecomePartner}
                            className="inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-semibold text-[#FF6B35] shadow-lg transition-transform hover:scale-[1.03] md:text-base"
                        >
                            Become a Partner
                            <ArrowRight className="h-5 w-5" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReferralBanner;
